import { render } from "../templates/scenario-benefits-tree.html?vue&type=template&id=c532009c&scoped=true"
import script from "./scenario-benefits-tree.vue?vue&type=script&lang=js"
export * from "./scenario-benefits-tree.vue?vue&type=script&lang=js"

import "./scenario-benefits-tree.vue?vue&type=style&index=0&id=c532009c&lang=scss&scoped=true"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c532009c"]])

export default __exports__